import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const handleScrollToContact = () => {
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const handleScrollToFeatures = () => {
    const el = document.querySelector('#features');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* 背景画像を左右反転 */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/122666497f4cd0a9fad8349ccfff36c2.jpg"
          alt=""
          className="w-full h-full object-cover object-top"
          style={{ transform: 'scaleX(-1)' }}
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-navy/80 via-navy/60 to-navy/30"></div>

      <div className="absolute top-24 left-1/2 -translate-x-1/2 md:left-auto md:translate-x-0 md:top-28 md:right-10 z-20">
        <div className="flex items-center gap-2 bg-accent text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-award-fill text-sm"></i>
          </span>
          業界初 48時間以内着工保証
        </div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 py-28 md:py-0">
        <div className="grid grid-cols-1 gap-8 items-center">
          <div
            className="max-w-2xl"
            style={{
              opacity: loaded ? 1 : 0,
              transform: loaded ? 'translateY(0)' : 'translateY(30px)',
              transition: 'opacity 0.8s ease, transform 0.8s ease',
            }}
          >
            <p className="text-accent font-display font-bold text-sm tracking-widest mb-4 uppercase">
              Toilet Specialist 48 — forty-eight
            </p>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6">
              そのトイレの悩み、<br />
              <span className="text-accent">48時間以内</span>に<br />
              解決します。
            </h1>
            <div className="border-l-4 border-accent pl-4 mb-8">
              <p className="text-white/90 text-base md:text-lg font-medium leading-relaxed">
                業界初「48時間以内着工保証」。<br />
                リフォームの<strong>『めんどくさい』</strong>をゼロにする、<br />
                地元密着の専門店。
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 mb-6">
              <a
                href="https://lin.ee/Su7CYDD"
                rel="nofollow"
                target="_blank"
                className="flex items-center justify-center gap-2 bg-[#00B900] hover:bg-[#009900] text-white px-7 py-4 rounded-full font-bold text-base whitespace-nowrap transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-0.5 cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-line-fill text-lg"></i>
                </span>
                LINEで簡単見積もり（無料）
              </a>
              <a
                href="tel:0297386660"
                className="flex items-center justify-center gap-2 bg-white/15 hover:bg-white/25 border border-white/50 text-white px-7 py-4 rounded-full font-bold text-base whitespace-nowrap transition-all duration-300 cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill text-lg"></i>
                </span>
                0297-38-6660
              </a>
            </div>

            <div className="flex items-center gap-2 mb-8">
              <button
                onClick={handleScrollToFeatures}
                className="flex items-center gap-1.5 text-white/70 hover:text-white text-sm transition-colors cursor-pointer"
              >
                詳しく見る
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-down-line text-sm"></i>
                </span>
              </button>
              <span className="text-white/30 text-xs">｜</span>
              <span className="text-white/50 text-xs">受付 9:00〜18:00（日・木定休）</span>
            </div>

            <div className="flex flex-wrap gap-6 mb-8">
              {[
                { num: '48h', label: '以内着工保証' },
                { num: '12', label: '厳選プラン' },
                { num: '0', label: '追加費用' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <p className="font-display font-black text-3xl text-accent leading-none">{stat.num}</p>
                  <p className="text-white/70 text-xs mt-1">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="bg-white/95 backdrop-blur-sm rounded-2xl px-5 py-4 flex items-center gap-4 border-l-4 border-accent max-w-sm">
              <div className="w-10 h-10 flex items-center justify-center bg-accent/10 rounded-full flex-shrink-0">
                <i className="ri-gift-fill text-accent text-xl"></i>
              </div>
              <div>
                <p className="text-xs text-accent font-bold tracking-wide uppercase mb-0.5">モニター特典</p>
                <p className="text-sm text-navy font-black leading-snug">2026年4月1日 サービス開始記念</p>
                <p className="text-xs text-gray-600 font-medium mt-0.5">
                  Amazon eギフト <strong className="text-accent text-sm">¥1,000</strong> 配布中！
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <button
          onClick={handleScrollToFeatures}
          className="flex flex-col items-center gap-2 text-white/60 hover:text-white transition-colors cursor-pointer"
        >
          <span className="text-xs tracking-widest">SCROLL</span>
          <span className="w-4 h-4 flex items-center justify-center animate-bounce">
            <i className="ri-arrow-down-line text-base"></i>
          </span>
        </button>
      </div>
    </section>
  );
}
